import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Page root for workspace pages. The workspace `<main>` owns the side padding;
 * this fills it completely. There are no width variants by design (spec-70):
 * every page has the same width and left edge. Inner readability columns go
 * inside it, left-aligned.
 */
export function PageContainer({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return (
    <div data-width="full" className={cn('w-full min-w-0', className)}>
      {children}
    </div>
  )
}
